import React from 'react';
import { Text } from '@chakra-ui/react';
import ModalShell from '../../../components/ui/ModalShell';
import { ff } from '../../../theme';

interface DeleteRequestModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  clientName?: string;
}

const DeleteRequestModal: React.FC<DeleteRequestModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
}) => {
  return (
    <ModalShell
      isOpen={isOpen}
      onClose={onClose}
      title="Delete Request"
      cancelLabel="Cancel"
      primary={{ label: 'Delete Request', onClick: onConfirm, isLoading, tone: 'danger' }}
    >
      <Text color={ff.text2}>
        Are you sure you want to delete this collaboration request? This action cannot be undone.
      </Text>
    </ModalShell>
  );
};

export default DeleteRequestModal;
